import React from 'react';

const OwnershipTransfer = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Payment and Transfer of Ownership</h1>

      <p>
        Upon the closing of the auction, both the Buyer and Seller are required to adhere to the following guidelines to ensure a smooth and timely transaction.
      </p>

      <div className="mb-5">
        <h3 className="fs-4 mb-3 ">For Buyers:</h3>
        <ol className="ps-3">
          <li className="mb-3">
            <strong>Payment Deadline</strong><br />
            Buyers must complete the full payment for the vehicle within one week from the closing of the auction.
          </li>

          <li className="mb-3">
            <strong>Loan Inability</strong><br />
            If the Buyer is unable to secure a loan for the intended Loan Amount within one (1) week from the signing of the Agreement, the Agreement will be voided, and the Seller will refund the Deposit. Documentation as proof of loan rejection must be submitted.
          </li>

          <li className="mb-3">
            <strong>Failure to Deliver</strong><br />
            If the Seller fails to deliver the vehicle by the scheduled date, the Buyer has the right to void this Agreement. In such cases, the Seller must refund the Deposit and compensate the Buyer for any additional costs incurred.
          </li>

          <li className="mb-3">
            <strong>Transaction Closure</strong><br />
            Once payment is made and the ownership transfer is completed, mark the transaction as “deal closed” on your dashboard. This helps finalize the deal and share your success story with the community.
          </li>
        </ol>
      </div>

      <div className="mb-5">
        <h3 className="fs-4 mb-3 ">For Sellers:</h3>
        <ol className="ps-3">
          <li className="mb-3">
            <strong>Transfer of Ownership</strong><br />
            Sellers with any outstanding loans must ensure that the transfer of ownership happens within one week from the closing of the auction.
          </li>

          <li className="mb-3">
            <strong>Sales Agreement Documentation</strong><br />
            It is highly recommended that both parties print the <strong>Vehicle Auction Sales Agreement Form</strong> from the dashboard to properly document the transaction.
          </li>

          <li className="mb-3">
            <strong>Seller Breach of Agreement</strong><br />
            If the Seller breaches this Agreement, they must refund the Deposit to the Buyer and compensate the Buyer with an amount equal to the value of the Deposit.
          </li>

          <li className="mb-3">
            <strong>Preserving Vehicle Condition</strong><br />
            The Seller must preserve the vehicle in its original condition from the signing of this Agreement. If the vehicle is not in the same condition, the Buyer may request a lower price or void the Agreement. The Seller will refund the Deposit and compensate the Buyer for any additional costs incurred.
          </li>

          <li className="mb-3">
            <strong>Handover of Vehicle Documents</strong><br />
            Upon delivery, the Seller is required to hand over the keys, remote controls, owner’s handbook, and any other related documents to the Buyer, where available.
          </li>
        </ol>
      </div>

      <div className="text-center">
        <h3 className="fs-4 mt-4">Share Your Success Story!</h3>
        <p>
          Don’t forget to click “deal closed” to share your successful auction experience with us. We’d love to hear your story and celebrate your success!
        </p>
      </div>
    </div>
  );
};

export default OwnershipTransfer;
